import axiosPrivateMl from "./axiosPrivateMl"

const fetchAllAdTemplates = async (requestData) => {
  return axiosPrivateMl.post(`fetch_ad_templates`, requestData)
}

const saveAdTemplate = async (requestData) => {
  return axiosPrivateMl.post(`save_ad_templates`, requestData)
}

const deleteAdTemplate = async (requestData) => {
  return axiosPrivateMl.post(`delete_ad_template`, requestData)
}

const updateAdTemplate = async (requestData) => {
  return axiosPrivateMl.post(`update_ad_template`, requestData)
}

export { fetchAllAdTemplates, saveAdTemplate, deleteAdTemplate, updateAdTemplate }
